import React, { useEffect, useState } from 'react';
import Confetti from "react-confetti";
import './Congratulations.css';
import { useUserAuth } from "../../context/UserAuthContext";

const CongratulationsPopup = ({ isVisible, onClose }) => {
    // Placeholder for handling input changes
    const { userDataLocal } = useUserAuth();
    const [isVisiblePopup, setIsVisiblePopup] = useState(false);
    const [levelTxt, setLevelTxt] = useState('FREE');
    const [showConfetti, setShowConfetti] = useState(true);


    useEffect(() => {
        setIsVisiblePopup(true);
        const timer = setTimeout(() => {
            setShowConfetti(false);
          }, 5000);
        return () => {
            setIsVisiblePopup(false);
            clearTimeout(timer);
        };
    }, []);

    useEffect(() => {
        if(userDataLocal !== null && userDataLocal !== undefined && userDataLocal !== 'null' && isVisible) {
            if(userDataLocal.VIPLevel > 0) {
                setLevelTxt('VIP');
            } 
            // else if(userDataLocal.VIPLevel === 2) {
            //     setLevelTxt('Business');
            // }
        }
    }, [userDataLocal, isVisible]);


    return (
        <div className={`popup-settingsnew-overlay ${isVisiblePopup ? 'active' : ''}`}>
            {showConfetti && (
                <div className='confetti-divstyle'>
                    <Confetti 
                    numberOfPieces={200}
                    wind={-0.057}
                    gravity={0.24}
                    />
                </div>)}
            <div className="popup-congratulations-container">
                <div className="popup-congratulations-header">
                    <p className="popup-congratulations-headtext">Congratulations!</p>
                </div>
                <div className="popup-congratulations-body">
                    <p className="congratulations-p">Successfully upgraded to {levelTxt}!</p>
                    <button
                        className="congratulations_btn"
                        onClick={onClose}
                        >
                        OK
                    </button>
                </div>   
            </div>
        </div>
    );
};

export default CongratulationsPopup;